var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h6',{staticClass:"data-field-label mr-1"},[(_vm.required)?_c('b',[_vm._v(_vm._s(_vm.label))]):[_vm._v(_vm._s(_vm.label))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }